export interface IAcademicPeriod {
	period: string;
	relevant: boolean;
}

export interface IConfig {
	serviceName: string;
	programIndexName: string;
	courseIndexName: string;
	queryKey: string;
	googleAnalyticsTrackingId: string;
	gtagAnalyticsPropertyId: string;
	administrationOrganization: string;
	administrationOrganizationHomePage: string;
	applicationName: string;
	courseSearchEnabled: boolean;
	periods: IAcademicPeriod[];
	defaultPeriod: string;

	disclaimerEnabled: boolean,
	disclaimerTitle: string,
	disclaimerBody: string,
	disclaimerAcknowledgement: string,
}

const source = window as unknown as { ambient: string }; // IAmbient;

const config = JSON.parse(atob(source.ambient)) as IConfig;

export default config;
